import styled from '@emotion/styled/macro'

import { flexCenter, pageContentDefaultSize } from 'style/emotion'
import mediaQuery from 'share/utils/mediaQuery'

const CoursesContainer = styled('div')`
  ${flexCenter}

  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
`

const AuthVerifyContainer = styled('section')`
  ${flexCenter}
  ${pageContentDefaultSize}

  flex-direction: column;
  height: auto;
  margin-top: 24px;

  ${mediaQuery('', 'laptop')} {
    margin-top: 3rem;
  }

  > h2 {
    margin-bottom: 32px;
    width: inherit;
  }

  > h1 {
    margin-bottom: 1rem;
    width: inherit;
  }

  > span {
    white-space: pre-line;
    width: inherit;
  }

  .verify-message-text {
    margin-bottom: 1.5rem;
    ${mediaQuery('', 'tablet')} {
      margin-bottom: 2rem;
    }
  }
`

const TwoBtnsContainer = styled('div')`
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  > button {
    flex: 1;

    :last-of-type {
      margin-left: 16px;
    }

    ${mediaQuery('mobile')} {
      flex: 1 0 100%;

      :last-of-type {
        margin-bottom: 16px;
        margin-left: 0;
        order: -1;
      }
    }
  }
`

const TwoBtnsOrderedContainer = styled('div')`
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  > button {
    flex: 1;

    :last-of-type {
      margin-left: 16px;
    }

    ${mediaQuery('mobile')} {
      flex: 1 0 100%;

      :last-of-type {
        margin-top: 16px;
        margin-left: 0px;
      }
    }
  }
`

export {
  AuthVerifyContainer,
  CoursesContainer,
  TwoBtnsContainer,
  TwoBtnsOrderedContainer
}
